import React from "react";
import ContactTable from "../components/ContactTable";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";

const ContactsPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get("customerId") ? searchParams.get("customerId")! : undefined;

    return (
        <Layout>
            <ContactTable customerId={customerId} />
        </Layout>
    );
};

export default ContactsPage;
